import * as React from 'react'
import ExternalRedirectModal from '../ExternalRedirectModal/ExternalRedirectModal'
import copy from '../../../assets/img/copy.png'
import { PromoCodeContainer, LoadingSpinner, ToolTip } from './LeaveModal.style'
import { APP_NAME } from '../../../static/constants'

const LeaveModal = ({
  isLoggedIn,
  promoCode,
  onClose,
  explore,
  ...restOfProps
}) => {
  const [copied, isCopied] = React.useState(false)
  const [message, setMesg] = React.useState('')

  React.useEffect(() => {
    if (copied) setTimeout(() => isCopied(false), 5000)
  }, [copied])

  const copyText = () => {
    const copyText = document.getElementById('promo-code')

    copyText.select()
    copyText.setSelectionRange(0, 99999) /*For mobile devices*/
    isCopied(true)
    try {
      document.execCommand('copy')
      setMesg('Copied!')
    } catch {
      setMesg('Unknown erro occured.')
    }
  }

  const handleClose = async () => {
    await isCopied(false)
    onClose()
  }
  const PromoCode = ({ code }) => (
    <>
      Use the promo code
      <PromoCodeContainer>
        {code === '' ? (
          <LoadingSpinner small />
        ) : (
          <>
            <input value={code ? code : ''} id="promo-code" readOnly />
            <button onClick={copyText}>
              <img src={copy} alt="copy" />
            </button>
          </>
        )}
        {copied && <ToolTip>{message}</ToolTip>}
      </PromoCodeContainer>
      to avail of special offers, whenever available.
    </>
  )

  let additionalDesc = undefined
  if (!explore)
    additionalDesc = isLoggedIn
      ? promoCode && <PromoCode code={promoCode} />
      : `Login or register to ${APP_NAME} to unlock a free promo code for select merchants.`

  return (
    <ExternalRedirectModal
      {...restOfProps}
      onClose={handleClose}
      zIndex={10025}
      isEngagement
      altHeader={`You’re now leaving ${APP_NAME}`}
      altDesc="By clicking proceed, you agree to be re-directed to our 3rd party merchant’s website. Your usage &amp; transactions will be governed by their terms &amp; conditions."
      additionalDesc={additionalDesc}
      shouldCloseOnOverlayClick={true}
    />
  )
}

LeaveModal.defaultProps = {
  // TODO: specify default props
}

LeaveModal.propTypes = {
  // TODO: specify prop types
}

export default LeaveModal
